// extracted by mini-css-extract-plugin
module.exports = {"list":"e2ff468f85--list--StB0k","item":"e2ff468f85--item--PcE_w","is-title":"e2ff468f85--is-title--yNHR9","footer":"e2ff468f85--footer--LZy6K"};